import { FormFieldType } from '@Shared.Angular/flowingly.services/flowingly.constants';
import { toCamelCaseDeep } from '@Shared.Angular/flowingly.services/case-converter';
import React from 'react';

type FlowHistoryFieldLabelProps = {
  fieldType?: string;
  fieldValue?: string;
  validationJson?: string;
};

const FlowHistoryFieldLabel: React.FC<FlowHistoryFieldLabelProps> = ({
  fieldType,
  fieldValue,
  validationJson
}) => {
  const getFormValue = (): string => {
    switch (fieldType) {
      case 'approvecomment':
        return 'Comment';
      case 'approval':
        return 'Approval Decision';
      default:
        return fieldValue || '';
    }
  };

  const showOptional = (type: string, validationJson: string) => {
    if (
      type === FormFieldType.LOOKUP ||
      type === FormFieldType.ATTACH_DOCUMENT
    ) {
      return false;
    }
    let validation: any;
    try {
      validation = toCamelCaseDeep(JSON.parse(validationJson));
    } catch (e) {
      // If JSON is invalid, treat as optional (safe fallback)
      return true;
    }

    if (!validation || !validation.required) {
      return true;
    }

    return false;
  };

  return (
    <>
      {getFormValue()}
      <span
        className={
          'field-label ' +
          (showOptional(fieldType || '', validationJson || '')
            ? 'optional'
            : '')
        }
      ></span>
    </>
  );
};

export default FlowHistoryFieldLabel;
